import Vapi from 'vuex-rest-api'
import http from 'src/http/index'
import utils from 'components/utils'
import { createSuccess, deleteSuccess, updateSuccess } from 'components/utils/storeUtils'

const variableState = {}

for (let i = 0; i < utils.variableList.length; i++) {
  variableState[utils.pluralMap[utils.variableList[i]]] = []
}

const vapi = new Vapi({
  axios: http.axios,
  baseURL: process.env.API_URL,
  state: variableState
})

for (let i = 0; i < utils.variableList.length; i++) {
  vapi
    .get({
      action: 'GET_' + utils.pluralMap[utils.variableList[i]].toUpperCase(),
      queryParams: true,
      path: `${utils.pathMap[utils.variableList[i]]}/variable/${utils.variableList[i]}`,
      property: utils.pluralMap[utils.variableList[i]]
    })
    .get({
      action: 'GET_ONE_' + utils.pluralMap[utils.variableList[i]].toUpperCase(),
      queryParams: true,
      property: utils.variableList[i],
      path: ({ id }) => `${utils.pathMap[utils.variableList[i]]}/variable/${utils.variableList[i]}/${id}`
    })
    .post({
      action: 'CREATE_' + utils.pluralMap[utils.variableList[i]].toUpperCase(),
      queryParams: true,
      property: utils.pluralMap[utils.variableList[i]],
      path: `${utils.pathMap[utils.variableList[i]]}/variable/${utils.variableList[i]}`,
      onSuccess: createSuccess(utils.variableList[i], utils.pluralMap[utils.variableList[i]])
    })
    .post({
      action: 'UPDATE_' + utils.pluralMap[utils.variableList[i]].toUpperCase(),
      queryParams: true,
      property: utils.pluralMap[utils.variableList[i]],
      path: ({ id }) => `${utils.pathMap[utils.variableList[i]]}/variable/${utils.variableList[i]}/${id}`,
      onSuccess: updateSuccess(utils.variableList[i], utils.pluralMap[utils.variableList[i]])
    })
    .delete({
      action: 'DELETE_' + utils.pluralMap[utils.variableList[i]].toUpperCase(),
      queryParams: true,
      property: utils.pluralMap[utils.variableList[i]],
      path: ({ id }) => `${utils.pathMap[utils.variableList[i]]}/variable/${utils.variableList[i]}/${id}`,
      onSuccess: deleteSuccess(utils.variableList[i])
    })
}

const variables = vapi.getStore()

export default variables
